import ResizeObserver from 'resize-observer-polyfill'

export default {
  props: {
    socialMode: {
      type: Boolean
    }
  },
  data () {
    return {
      mounted: false,
      height: null
    }
  },
  mounted () {
    const resizeObserver = new ResizeObserver(() => {
      this.$emit('resized')
      this.setHeight()
    })

    this.$nextTick(() => {
      this.mounted = true
      resizeObserver.observe(this.$el)
    })
  },
  watch: {
    socialMode () {
      this.setHeight()
    }
  },
  methods: {
    setHeight () {
      this.height = this.socialMode ? this.socialModeHeight : null
    }
  },
  computed: {
    socialModeHeight: {
      cache: false,
      get () {
        if (!this.mounted) {
          return null
        }
        return (this.$el.offsetWidth * 5 / 4) - this.titleAndDescriptionHeight
      }
    },
    titleHeight: {
      cache: false,
      get () {
        if (!this.mounted) {
          return 0
        }
        return this.$el.querySelector('h1, h2, h3, h4, h5').offsetHeight
      }
    },
    descriptionHeight: {
      cache: false,
      get () {
        if (!this.mounted) {
          return 0
        }
        return this.$el.querySelector('h1 + p, h2 + p, h3 + p, h4 + p, h5 + p').offsetHeight
      }
    },
    titleAndDescriptionHeight: {
      cache: false,
      get () {
        return this.titleHeight + this.descriptionHeight
      }
    }
  }
}
